import { ARROW_TYPES, DEFAULT_ARROW_TYPE } from '../lib/lineStyles';

// Werkzeug-Symbole, die so aussehen wie das, was das Werkzeug zeichnet (Props wie lucide-Icons)

export const ArrowToolIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 20 L15.5 8.5" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M20.5 3.5 L18.6 12.4 L11.6 5.4 Z" fill="#dc2626" />
  </svg>
);

export const HoseToolIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M3 18 C 8 5, 13 21, 21 7" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="3" cy="18" r="1.8" fill="#2563eb" />
    <circle cx="21" cy="7" r="1.8" fill="#2563eb" />
  </svg>
);

// Vorschau einer Pfeilart im Elementkatalog: Farbe, Linienart und Spitze wie auf der Karte
export const ArrowTypeIcon = ({ type, className }) => {
  const style = ARROW_TYPES[type] || ARROW_TYPES[DEFAULT_ARROW_TYPE];
  return (
    <svg className={className} viewBox="0 0 32 16" fill="none" aria-hidden="true">
      <path d={style.head === 'filled' ? 'M2 8 H22' : 'M2 8 H28'} stroke={style.color} strokeWidth="2.5"
        strokeDasharray={style.dashed ? '4 3' : undefined} />
      {style.head === 'filled'
        ? <path d="M21 2.5 L30 8 L21 13.5 Z" fill={style.color} />
        : <path d="M22 2.5 L29 8 L22 13.5" stroke={style.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />}
    </svg>
  );
};
